import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  getDropdownLanguagesList, languageCodes,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  IfacilitiesCategoriesStore,
} from '../../mobx-store/storeInterfaces/facilitiesCategoriesInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import classes from './addEditFacilityCategory.module.scss';
import { countriesIsoCodes } from '../../constants/countries';
import { facilityTypes } from '../facilitiesMangementScreen/facilities';
import queryString from 'query-string';

interface IProps extends WithSnackbarProps {
  facilitiesCategoriesStore: IfacilitiesCategoriesStore;
  countryStore: CountryStore;
  match: any;
  history: any;
}

interface IState {
  formFields: FormField[];
  loading: boolean;
  loadingManagedCountries: boolean;
  processing: boolean;
  selectedLang: string;
  facilityCategoryType: any;
}

@inject('facilitiesCategoriesStore')
@inject('countryStore')
@observer
export class AddEditFacilityCategory extends Component<IProps & RouteComponentProps, IState> {
  isNew = false;

  isEgypt = true;

  categoryId = -1;

  pageTitle = '';

  lastHistory = -1;

  categoryFormTitle = '';

  categorySchema: any;

  submitButton: any;

  cancelButton: any;

  dropdownLanguages: {
    langList: {langCode: string; langValue: string} [];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null = null;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  initializeComponent(props: IProps & RouteComponentProps, isConstructor = true) {
    if (props.match.params.id) {
      this.isNew = false;
      this.categoryId = props.match.params.id;
      this.pageTitle = translate('editFacilityCategoryPageTitle', {
      });
    } else {
      this.isNew = true;
      this.pageTitle = translate('addFacilityCategoryPageTitle', {
      });
    }
    this.initCategorySchema();

    this.state = {
      selectedLang: this.isNew && this.isEgypt
        ? languageCodes.arabic : languageCodes.english,
      processing: false,
      loadingManagedCountries: !this.isNew,
      loading: !this.isNew,
      facilityCategoryType: this.getQueryParam(),
      formFields: [],
    };

    this.setState({
      loading: true,
    }, () => {
      this.setState({
        formFields: this.getFOrmFields(),
      }, () => {
        this.setState({
          loading: false,
          loadingManagedCountries: false,
        });
      });
    });

    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.categoryFormTitle = translate('facilityCategoryFormTitle', {
    });
    this.dropdownLanguages = this.getDropdownLanguages();
  }

  getDropdownLanguages = () => {
    if (this.isNew) {
      return null;
    }
    return {
      langList: getDropdownLanguagesList(),
      selectedLang: this.isEgypt ? languageCodes.english : this.state.selectedLang,
      label: 'Select Languages',
      onChange: this.handelLanguageChange,
    };
  };

  componentWillReceiveProps(nextProps: IProps & RouteComponentProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.lastHistory = -2;
      this.initializeComponent(nextProps, false);
      this.setState({
        loadingManagedCountries: false,
        facilityCategoryType: this.getQueryParam(),
      });
      this.forceUpdate();
      if (!this.isNew) {
        this.props.facilitiesCategoriesStore.getFacilityCategoryById(this.categoryId, languageCodes.english)
          .then(() => {
            this.updateStateWithCategoryData();
          }).catch(() => {
            this.setState({
              loading: false,
            });
          });
      }
    }
  }

  handelLanguageChange = (langCode: string) => {
    if (langCode !== this.state.selectedLang) {
      this.setState({ selectedLang: langCode }, () => {
        this.setState({
          formFields:  this.getFOrmFields()
        });
        if (!this.isNew) {
          this.getFacilityCategory(langCode);
        }
      });
    }
  };

  initCategorySchema = () => {
    this.categorySchema = Yup.object().shape({
      title: Yup.string()
        .required('Required'),
        isActive: Yup.boolean().default(true),
        imageUrl: Yup.array(),
    });
  };

  getFOrmFields = (): FormField[] => {
    const formFields: FormField[] = [
      {
        name: 'title',
        label: this.state?.selectedLang === languageCodes.arabic ? translate('editFacilityCategoryArabicTitle', {
        }) : translate('editFacilityCategoryEnglishTitle', {
        }),
        type: 'text',
        filedType: 'InputField',
      },
      {
        name: 'imageUrl',
        label: translate('addFacilityCategoryImage', {
        }),
        filedType: 'GalleryField',
        isLimitToOneImage: true,
        accept: 'image/*',
        size: 200,
      },
      {
        name: 'isActive',
        label: translate('addFacilityCategoryPageFormStatus', {
        }),
        filedType: 'ToggleButtonField',
        activeLabel: translate('facilitiesCategoriesListStatusActive', {
        }),
        inactiveLabel: translate('facilitiesCategoriesListStatusInActive', {
        }),
        value: true,
      },
    ];
    const queryType = this.getQueryParam();
    if (queryType === facilityTypes.MARKETING) {
      return formFields.filter((formField: FormField) => {
        return formField.name !== 'imageUrl';
      })
    }
    return formFields;
  };

  navigateBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (values: any): void => {
    const {
      countryStore,
    } = this.props;
    values.availableCountries = countryStore.managedCountries.map((country: ICountry) => country.isoCode);
    values.type = this.state.facilityCategoryType;

    this.setState({
      processing: true,
    });
    if (this.isNew) {
      try {
        this.props.facilitiesCategoriesStore.createFacilityCategory(values)
          .then((facilityCategoryId) => {
            if (this.isEgypt) {
              this.props.history.push(`${facilityCategoryId}/edit`);
            } else {
              this.props.history.go(this.lastHistory);
            }
          });
      } catch {
        this.setState({
          processing: false,
        });
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 5000, 'error');
      }
    } else {
      this.props.facilitiesCategoriesStore.updateFacilityCategory(values, this.categoryId, this.state.selectedLang)
        .then(() => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 5000, 'success');
          this.props.history.go(this.lastHistory);
        }).catch(() => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 5000, 'error');
        });
    }
  };

  getSubmitButton = () => ({
    title: (this.isNew && this.isEgypt ? 'To Next Language' : 'Save Changes'),
    onSubmit: this.handleSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.navigateBack,
  });

  updateStateWithCategoryData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      formFieldsWithData.push({
        ...field, value: this.props.facilitiesCategoriesStore.selectedCategory[field.name],
      });
    }
    this.setState({
      formFields: formFieldsWithData, loading: false,
    });
  };

  getFormPageHeader = () => (
    <div className={classes.header}>
      { this.isNew
        && (
          <IconButton
            className={classes.backButton}
            onClick={() => this.props.history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
        )}
      <Typography className={classes.title} variant="h6" gutterBottom>
        {this.pageTitle}
      </Typography>
    </div>
  );

  render() {
    return (
      <div className={classes.container}>
        {this.getFormPageHeader()}
        <div className={classes.content}>
          {this.state.loading || this.state.loadingManagedCountries?
             <Spinner/>
            : <GeneralFormComponent dropdownLanguages={this.isEgypt ? this.dropdownLanguages : null}
                                    formTitle={this.categoryFormTitle}
                                    fields={this.state.formFields}
                                    formSchema={this.categorySchema}
                                    submitButton={this.submitButton}
                                    cancelButton={this.cancelButton}
                                    processing={this.state.processing}/>
          }
        </div>
      </div>
    );
  }

  getQueryParam = () => {
    const queryValues = queryString.parse(this.props.location.search);
    const facilityTypeToCall: any = (queryValues.type) ? queryValues.type : facilityTypes.ALL;

    return facilityTypeToCall;
  }


  async componentDidMount() {
    const {
      countryStore, facilitiesCategoriesStore,
    } = this.props;

    await countryStore.getUserManagedCountries();
    if (this.props.countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
      this.isEgypt = true;
    }
    this.setState({
      selectedLang: this.isNew && this.isEgypt
        ? languageCodes.arabic : languageCodes.english,
    }, () => {
      this.setState({
        formFields: this.getFOrmFields(),
      });
    });
    this.submitButton = this.getSubmitButton();
    this.setState({
      loadingManagedCountries: false,
    });
    if (!this.isNew) {
      facilitiesCategoriesStore.getFacilityCategoryById(this.categoryId, this.state.selectedLang)
        .then(() => {
          this.updateStateWithCategoryData();
        }).catch(() => {
          this.setState({
            loading: false,
          });
        });
    }
  }

  getFacilityCategory = (langCode: string) => {
    this.setState({
      loading: true,
    });
    this.props.facilitiesCategoriesStore.getFacilityCategoryById(this.categoryId, langCode)
      .then(() => {
        this.updateStateWithCategoryData();
        this.dropdownLanguages!.selectedLang = langCode;
        this.setState({
          selectedLang: langCode,
        });
      }).catch(() => {
        this.setState({
          loading: false,
        });
      });
  };
}

export default withRouter(AddEditFacilityCategory);
